import React, { useState, useEffect, useRef } from 'react'; // useRef ইম্পোর্ট করা হয়েছে
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import FAQPage from './components/FAQPage';
import BlogList from './components/BlogList';
import ParcelTrackingPage from "./components/ParcelTrackingPage";
import BlogDetail from './components/BlogDetail';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import NotFoundPage from './components/NotFoundPage';
import Lottie from 'lottie-react';
import animationData from './assets/elevatemart_loading.json';
import DeliveryManInfo from './components/DeliveryManInfo';
import LandingPage from './components/LandingPage';
import { useUTM } from './hooks/useUTM'; // ✅ import

// import GetCurrentAddress from "./components/gps_location";
// Facebook Pixel লাইব্রেরি ইম্পোর্ট করুন
import ReactPixel from 'react-facebook-pixel';
// Google analytics
import ReactGA from "react-ga4";
// কম্পোনেন্ট ইম্পোর্ট করুন
import Header from './components/Header';
import Footer from './components/Footer';
import ProductList from './components/ProductList';
import ProductDetails from './components/ProductDetails';
import CartPage from './components/CartPage';
import CheckoutPage from './components/CheckoutPage';
import AboutUsPage from './components/AboutUsPage';
import RefundPolicyPage from './components/RefundPolicyPage';
import ScrollToTop from './components/ScrollToTop';
import ThankYouPage from './components/ThankYouPage';
import OrderHistoryPage from './components/OrderHistoryPage';
import FavoritesPage from './components/FavoritesPage';
import SearchOverlay from './components/SearchOverlay';
import PromoPopup from './components/PromoPopup';
import PhoneInputPopup from './components/PhoneInputPopup';

import LoginPage from './components/LoginPage';
import ProfilePage from './components/ProfilePage';
import ContactUsPage from './components/ContactUsPage';
import AllProduct from './components/AllProduct';
import MyOrdersPage from './components/MyOrdersPage';
import PrivacyPolicy from './components/PrivacyPolicy';
import BangladeshLocation from './components/BangladeshLocation';
import usePageTracking from "./components/usePageTracking";
// import GoogleOneTap from './components/GoogleOneTap';
import { jwtDecode } from 'jwt-decode';
import FacebookPrivacyPolicy from './components/FacebookPrivacyPolicy';
// import { useRealtimeTracking } from './hooks/useRealtimeTracking';
import { VoiceReceiver } from './components/VoiceReceiver';
import BottomNavigation from './components/BottomNavigation';
import { LicenseGuard } from './LicenseGuard';

// --- Facebook Pixel ID সেট করুন ---
const FACEBOOK_PIXEL_ID = ''; // <-- এখানে আপনার আসল Facebook Pixel ID দিন
// ----------------------------------
// 2755389891324026
// 2755389891324026
// আপনার GA4 Measurement ID দিন
const GA_MEASUREMENT_ID = "dfgbh";
ReactGA.initialize(GA_MEASUREMENT_ID);

// G-VBW94Z111P


function getFbClickId() {
  const match = document.cookie.match(/_fbc=([^;]*)/);
  return match ? match[1] : null;
}

function getFbBrowserId() {
  const match = document.cookie.match(/_fbp=([^;]*)/);
  return match ? match[1] : null;
}

const externalId = localStorage.getItem('client_id');

if (typeof window !== 'undefined' && !window.fbq) {


  const fbc = getFbClickId();
  const fbp = getFbBrowserId();

  const advancedMatching = {
    external_id: externalId,
    fbc,
    fbp,
  };


  if (process.env.NODE_ENV === 'production') {
    ReactPixel.init(FACEBOOK_PIXEL_ID, advancedMatching, { autoConfig: true, debug: false });
  } else {
    ReactPixel.init(FACEBOOK_PIXEL_ID, advancedMatching, { autoConfig: true, debug: true });
    console.log("Facebook Pixel initialized in DEV mode.");
  }
}

// কিছু ডামি পণ্য ডেটা (যদি API থেকে ডেটা না আসে তাহলে এটি ফলব্যাক হিসাবে থাকবে)
const dummyProducts = [
  // ... আপনার আগের ডামি প্রোডাক্ট ডেটা ...
  {
    id: "1",
    name: 'শার্ট - প্রিমিয়াম কটন',
    image: 'https://via.placeholder.com/300x300/ADD8E6/000000?text=Shirt_1',
    galleryImages: [
      'https://via.placeholder.com/600x400/ADD8E6/000000?text=Shirt_View1',
      'https://via.placeholder.com/600x400/87CEFA/000000?text=Shirt_View2',
      'https://via.placeholder.com/600x400/6495ED/000000?text=Shirt_View3',
    ],
    originalPrice: 1200,
    price: 960,
    buyingPrice: 700,
    discount: '20% off',
    isPopular: false,
    stock: 50,
    buyers: 120,
    youtubeUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
    description: 'উচ্চমানের কটন দিয়ে তৈরি একটি আরামদায়ক শার্ট। আধুনিক ডিজাইনের সাথে ঐতিহ্যবাহী সেলাইয়ের মিশেল। দৈনন্দিন ব্যবহার এবং বিশেষ অনুষ্ঠানের জন্য উপযুক্ত। এটি সব ঋতুতে পরিধানযোগ্য এবং ধোয়ার পর সঙ্কুচিত হয় না। শার্টটি বিভিন্ন রঙ এবং আকারে উপলব্ধ, যা আপনাকে আপনার পছন্দের স্টাইল বেছে নিতে সাহায্য করবে।',
    reviews: [
      { id: 1, user: 'আরিফ হোসেন', rating: 5, comment: 'অসাধারণ শার্ট, মান খুব ভালো এবং পরাতেও আরামদায়ক!' },
      { id: 2, user: 'নাসরিন আক্তার', rating: 4, comment: 'ডিজাইনটা ভালো লেগেছে, তবে ডেলিভারি একটু দেরি হয়েছে।' },
    ],
    isSizeAvailable: true,
    sizes: ['S', 'M', 'L', 'XL'],
    isColorAvailable: true,
    colors: [{ name: 'নীল', hex: '#ADD8E6' }, { name: 'সাদা', hex: '#FFFFFF' }],
    PAW: 0.3,
    PCW: 0.1,
  },
  {
    id: "2",
    name: 'প্যান্ট - ডেনিম জিন্স',
    image: 'https://via.placeholder.com/300x300/87CEFA/000000?text=Pant_2',
    galleryImages: [
      'https://via.placeholder.com/600x400/87CEFA/000000?text=Jeans_View1',
      'https://via.placeholder.com/600x400/4682B4/FFFFFF?text=Jeans_View2',
      'https://via.placeholder.com/600x400/6495ED/000000?text=Jeans_View3',
    ],
    originalPrice: 1500,
    price: 1200,
    buyingPrice: 900,
    discount: '20% off',
    isPopular: true,
    stock: 30,
    buyers: 95,
    youtubeUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
    description: 'স্টাইলিশ এবং টেকসই ডেনিম জিন্স। আরামদায়ক ফিট এবং দীর্ঘস্থায়ী উপাদান দিয়ে তৈরি। বিভিন্ন আকারের জন্য উপলব্ধ। এটি আপনার দৈনন্দিন ফ্যাশনের জন্য একটি নিখুঁত সংযোজন। এই জিন্সটি ক্যাজুয়াল এবং সেমি-ফরমাল উভয় লুকেই মানানসই।',
    reviews: [
      { id: 3, user: 'তানভীর আহমেদ', rating: 5, comment: 'জিন্সটি ফিটিং এবং দেখতে দারুন। দাম অনুযায়ী সেরা।' },
      { id: 4, user: 'শারমিন সুলতানা', rating: 4, comment: 'কালারটা ছবিতে যেমন ছিল, ঠিক তেমন আসেনি। তবে কোয়ালিটি ভালো।' },
    ],
    isSizeAvailable: true,
    sizes: ['28', '30', '32', '34', '36'],
    isColorAvailable: true,
    colors: [{ name: 'নীল ডেনিম', hex: '#4682B4' }, { name: 'কালো ডেনিম', hex: '#000000' }],
    PAW: 0.6,
    PCW: 0.2,
  },
  {
    id: "3",
    name: 'টি-শার্ট - গ্রাফিক ডিজাইন',
    image: 'https://via.placeholder.com/300x300/FFB6C1/000000?text=T-Shirt_3',
    galleryImages: [
      'https://via.placeholder.com/600x400/FFB6C1/000000?text=Tshirt_View1',
      'https://via.placeholder.com/600x400/FF69B4/FFFFFF?text=Tshirt_View2',
      'https://via.placeholder.com/600x400/CD5C5C/000000?text=Tshirt_View3',
    ],
    originalPrice: 800,
    price: 640,
    buyingPrice: 400,
    discount: '20% off',
    isPopular: false,
    stock: 70,
    buyers: 150,
    youtubeUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
    description: 'আড়ম্বরপূর্ণ গ্রাফিক ডিজাইনের টি-শার্ট। আরামদায়ক ফেব্রিক এবং ট্রেন্ডি প্রিন্ট। এটি আপনার ফ্যাশন স্টেটমেন্টের জন্য উপযুক্ত।',
    reviews: [],
    isSizeAvailable: true,
    sizes: ['S', 'M', 'L', 'XL'],
    isColorAvailable: false,
    colors: [],
    PAW: 0.2,
    PCW: 0.05,
  },
  {
    id: "4",
    name: 'হুডি - উইন্টার কালেকশন',
    image: 'https://via.placeholder.com/300x300/A2D2FF/000000?text=Hoodie_4',
    galleryImages: [
      'https://via.placeholder.com/600x400/A2D2FF/000000?text=Hoodie_View1',
      'https://via.placeholder.com/600x400/89CFF0/000000?text=Hoodie_View2',
    ],
    originalPrice: 2000,
    price: 1800,
    buyingPrice: 1500,
    discount: '10% off',
    isPopular: true,
    stock: 25,
    buyers: 70,
    youtubeUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
    description: 'শীতের জন্য উষ্ণ এবং আরামদায়ক হুডি। টেকসই উপকরণ দিয়ে তৈরি এবং আধুনিক ডিজাইন।',
    reviews: [
      { id: 5, user: 'মীম আক্তার', rating: 5, comment: 'খুব উষ্ণ এবং আরামদায়ক। ডিজাইনটাও দারুণ!' },
    ],
    isSizeAvailable: true,
    sizes: ['M', 'L', 'XL', 'XXL'],
    isColorAvailable: true,
    colors: [{ name: 'কালো', hex: '#000000' }, { name: 'ধূসর', hex: '#808080' }],
    PAW: 0.7,
    PCW: 0.25,
  },
  {
    id: "5",
    name: 'জুতা - স্পোর্টস সু',
    image: 'https://via.placeholder.com/300x300/C8A2C8/000000?text=Shoes_5',
    galleryImages: [
      'https://via.placeholder.com/600x400/C8A2C8/000000?text=Shoes_View1',
      'https://via.placeholder.com/600x400/9966CC/FFFFFF?text=Shoes_View2',
    ],
    originalPrice: 3000,
    price: 2700,
    buyingPrice: 2200,
    discount: '10% off',
    isPopular: true,
    stock: 40,
    buyers: 110,
    youtubeUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
    description: 'দৌড়ানো এবং হাঁটার জন্য উপযুক্ত স্পোর্টস সু। হালকা এবং আরামদায়ক।',
    reviews: [],
    isSizeAvailable: true,
    sizes: ['39', '40', '41', '42', '43', '44'],
    isColorAvailable: true,
    colors: [{ name: 'সাদা', hex: '#FFFFFF' }, { name: 'কালো', hex: '#000000' }, { name: 'লাল', hex: '#FF0000' }],
    PAW: 1.0,
    PCW: 0.3,
  },
];


// MainContent এখন শুধু সাধারণ কন্টেন্টের জন্য, লোডারের জন্য নয়
const MainContent = styled.main`
  min-height: calc(100vh - 120px);
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;

 @media (max-width: 768px) {
    padding-bottom: 90px; /* Bottom navigation এর জন্য extra space */
  }
`;

// Lottie লোডারের জন্য নতুন স্টাইলড কম্পোনেন্ট
const FullScreenLoader = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  width: 100vw;
  position: fixed; /* পুরো ভিউপোর্ট জুড়ে থাকার জন্য */
  top: 0;
  left: 0;
  background-color: #ffffff; /* আপনার অ্যাপের ব্যাকগ্রাউন্ড কালার অনুযায়ী সেট করুন */
  z-index: 9999; /* নিশ্চিত করুন এটি অন্য সব উপাদানের উপরে থাকে */
`;

const ErrorMessage = styled.div`
  text-align: center;
  font-size: 1.5em;
  color: #dc3545;
  padding: 50px;
`;

// ProtectedRoute কম্পোনেন্ট
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated } = useAuth();
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  return children;
};

// --- সংশোধিত কাস্টম হুক: প্রতিটি রাউট চেঞ্জে PageView ট্র্যাক করার জন্য ---
function useFacebookPixelPageView() {
  const location = useLocation();
  const lastPathname = useRef(''); // শেষ ট্র্যাক করা pathname সংরক্ষণ করতে

  useEffect(() => {
    // শুধুমাত্র যদি pathname পরিবর্তিত হয় এবং fbq লোড হয়ে থাকে তাহলে ট্র্যাক করুন
    if (window.fbq && location.pathname !== lastPathname.current) {
      ReactPixel.pageView();
      lastPathname.current = location.pathname; // নতুন pathname সংরক্ষণ করুন
      console.log(`Facebook Pixel: PageView Tracked for: ${location.pathname}`);
    } else if (!window.fbq) {
      console.warn('Facebook Pixel (fbq) not loaded');
    }
  }, [location.pathname]); // শুধুমাত্র location.pathname এর উপর নির্ভর করুন
}
// ------------------------------------------------------------------


// AppContent কম্পোনেন্টটি AppProvider এর ভিতরে থাকবে
function AppContent() {
  const location = useLocation();
  // const userId = useRealtimeTracking();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // --- Pagination States ---
  const [currentPage, setCurrentPage] = useState(1);
  const [productsPerPage] = useState(20);
  const [totalPages, setTotalPages] = useState(1);
  // --- End Pagination States ---

  const [cart, setCart] = useState([]);
  const [favoriteProducts, setFavoriteProducts] = useState(() => {
    const savedFavorites = localStorage.getItem('favoriteProducts');
    return savedFavorites ? JSON.parse(savedFavorites) : {};
  });
  const [orders, setOrders] = useState(() => {
    const savedOrders = localStorage.getItem('userOrders');
    return savedOrders ? JSON.parse(savedOrders) : [];
  });

  const [searchTerm, setSearchTerm] = useState('');
  const [isSearchOverlayOpen, setIsSearchOverlayOpen] = useState(false);
  const [isPromoPopupOpen, setIsPromoPopupOpen] = useState(false);
  const [promoImageUrl, setPromoImageUrl] = useState('');
  const { getAuthHeaders, isAuthenticated, userInfo, fetchUserInfo, logout } = useAuth();

  const [isPhonePopupOpen, setIsPhonePopupOpen] = useState(false);

  // শুধুমাত্র /l/ দিয়ে শুরু হওয়া routes হলো landing page
  const isLandingPage = location.pathname.startsWith('/l/');


  // --- Facebook Pixel PageView Tracking in AppContent ---
  useFacebookPixelPageView(); // এখানে সংশোধিত হুক কল করা হয়েছে
  // ----------------------------------------------------


  useEffect(() => {
    const fetchPromoImage = async () => {
      const flaskApiUrl = 'https://aman-life-style-bd-main-server.sparkx-ai.shop/active_promo_image';

      try {
        const response = await fetch(flaskApiUrl);
        if (!response.ok) {
          if (response.status === 404) {
            throw new Error('কোনো সক্রিয় পপআপ ইমেজ পাওয়া যায়নি।');
          }
          throw new Error(`HTTP ত্রুটি! স্থিতি: ${response.status}`);
        }
        const data = await response.json();
        if (data && data.imageUrl) {
          setPromoImageUrl(data.imageUrl);
          setIsPromoPopupOpen(true);
        } else {
          setIsPromoPopupOpen(false);
        }
      } catch (err) {
        setIsPromoPopupOpen(false);
        console.error(" API কল করার সময় ত্রুটি:", err);
      }
      // Note: Setting loading to false should ideally happen after all initial data fetching is complete
      // For now, keeping it here for promo image, but it might be better handled globally after products too.
    };

    fetchPromoImage();
  }, []);

  // API থেকে পণ্য ডেটা ফেচ করার জন্য useEffect (এখন Pagination প্যারামিটার সহ)
  useEffect(() => {
    const fetchProductsData = async () => {
      try {
        setLoading(true); // পণ্য ফেচ শুরু হওয়ার আগে লোডিং সত্য করুন
        const url = new URL('https://aman-life-style-bd-main-server.sparkx-ai.shop/products');
        url.searchParams.append('page', currentPage);
        url.searchParams.append('per_page', productsPerPage);

        const response = await fetch(url.toString(), {
          headers: getAuthHeaders(),
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        setProducts(data.products);
        setTotalPages(data.total_pages);
      } catch (err) {
        console.error("Error fetching products:", err);
        setError("পণ্য লোড করা যায়নি। অনুগ্রহ করে পরে আবার চেষ্টা করুন।");
        setProducts(dummyProducts);
        setTotalPages(1);
      } finally {
        setLoading(false); // পণ্য ফেচ শেষ হওয়ার পর লোডিং মিথ্যা করুন
      }
    };

    fetchProductsData();
  }, [getAuthHeaders, currentPage, productsPerPage]);

  // AuthContext থেকে userInfo আসার পর ফোন পপআপ ম্যানেজ করা
  useEffect(() => {
    if (isAuthenticated && userInfo && !userInfo.phone_number) {
      setIsPhonePopupOpen(true);
    } else {
      setIsPhonePopupOpen(false);
    }
  }, [isAuthenticated, userInfo]);

  // localStorage এ favorites সেভ করুন
  useEffect(() => {
    localStorage.setItem('favoriteProducts', JSON.stringify(favoriteProducts));
  }, [favoriteProducts]);

  // localStorage এ orders সেভ করুন
  useEffect(() => {
    localStorage.setItem('userOrders', JSON.stringify(orders));
  }, [orders]);


  const addToCart = (product) => {
    setCart((prevCart) => {
      const existingItem = prevCart.find((item) => item.id === product.id);
      if (existingItem) {
        return prevCart.map((item) =>
          item.id === product.id ? { ...item, quantity: item.quantity + 1 } : item
        );
      } else {
        return [...prevCart, { ...product, quantity: 1 }];
      }
    });
    // // --- Facebook Pixel: AddToCart Event ---
    // // আপনার AddToCart ইভেন্ট কোড এখানে থাকতে পারে, এটা PageView সমস্যার সাথে সম্পর্কিত নয়।
    // // যদি আপনি এটি সক্রিয় করতে চান, তাহলে নিচের কমেন্টগুলো তুলে দিন:
    // // if (typeof window !== 'undefined' && window.fbq) {
    // //   ReactPixel.track('AddToCart', {
    // //     content_ids: [product.id],
    // //     content_name: product.name,
    // //     currency: 'BDT', // আপনার কারেন্সি অনুযায়ী পরিবর্তন করুন
    // //     value: product.price,
    // //     content_type: 'product',
    // //   });
    // //   console.log('Facebook Pixel: AddToCart event fired for product:', product.name);
    // // }
    // // ---------------------------------------
  };

  const updateCartQuantity = (productId, quantity) => {
    setCart((prevCart) =>
      prevCart.map((item) =>
        item.id === productId ? { ...item, quantity: Math.max(1, quantity) } : item
      )
    );
  };

  const removeFromCart = (productId) => {
    setCart((prevCart) => prevCart.filter((item) => item.id !== productId));
  };

  const updateCartItemOptions = (itemId, optionType, value) => {
    setCart((prevCart) =>
      prevCart.map((item) =>
        item.id === itemId
          ? { ...item, [optionType]: value }
          : item
      )
    );
  };

  const toggleFavorite = (productId) => {
    setFavoriteProducts((prevFavorites) => ({
      ...prevFavorites,
      [productId]: !prevFavorites[productId],
    }));
  };

  const isFavorite = (productId) => {
    return !!favoriteProducts[productId];
  };

  const addOrder = (newOrder) => {
    setOrders((prevOrders) => [...prevOrders, newOrder]);
  };

  const addReviewToOrder = (orderId, productId, rating, comment) => {
    setOrders((prevOrders) =>
      prevOrders.map((order) =>
        order.orderId === orderId
          ? {
            ...order,
            items: order.items.map(item =>
              item.productId === productId
                ? { ...item, review: { rating, comment } }
                : item
            ),
            reviewAdded: true,
          }
          : order
      )
    );
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleSearchSubmit = () => {
    // This function can be expanded later for backend search with pagination
  };

  const getFilteredProducts = () => {
    if (!searchTerm) {
      return products;
    }
    const lowerCaseSearchTerm = searchTerm.toLowerCase();
    return products.filter(
      (product) =>
        product.name.toLowerCase().includes(lowerCaseSearchTerm) ||
        product.description.toLowerCase().includes(lowerCaseSearchTerm)
    );
  };

  const filteredProducts = products;

  const [offerContact, setOfferContact] = useState('');
  const [offerType, setOfferType] = useState('email');

  const handleOfferSubmit = (e) => {
    e.preventDefault();
    if (offerContact.trim() === '') {
      alert('অনুগ্রহ করে আপনার ইমেল বা ফোন নম্বর দিন।');
      return;
    }
    console.log(`অফার গ্রহণ করা হয়েছে! ${offerType}: ${offerContact}`);
    alert(`আপনার ${offerType} (${offerContact}) সফলভাবে গ্রহণ করা হয়েছে। আমরা শীঘ্রই আপনার সাথে যোগাযোগ করব!`);
    setOfferContact('');
  };

  const handlePhoneSubmit = async (phoneNumber) => {
    try {
      const response = await fetch('https://aman-life-style-bd-main-server.sparkx-ai.shop/update_user_profile', {
        method: 'POST',
        headers: getAuthHeaders(),
        body: JSON.stringify({ phone_number: phoneNumber }),
      });

      if (response.ok) {
        await fetchUserInfo();
        setIsPhonePopupOpen(false);
        alert('আপনার ফোন নম্বর সফলভাবে যোগ করা হয়েছে!');
      } else {
        const errorData = await response.json();
        alert(`ফোন নম্বর আপডেট করতে সমস্যা হয়েছে: ${errorData.error}`);
      }
    } catch (error) {
      console.error('ফোন নম্বর আপডেট করার API কল করতে সমস্যা:', error);
      alert('ফোন নম্বর আপডেট করতে নেটওয়ার্ক সমস্যা হয়েছে।');
    }
  };

  // --- Purchase event data management (passing to ThankYouPage) ---
  const [lastOrderData, setLastOrderData] = useState(null);

  const handleCheckoutComplete = (orderInfo) => {
    setCart([]); // কার্ট খালি করুন
    addOrder(orderInfo); // অর্ডার হিস্ট্রিতে যোগ করুন
    setLastOrderData(orderInfo); // ThankYouPage এ পাঠানোর জন্য অর্ডার ডেটা সংরক্ষণ করুন
    // এখানে কোনো Navigate করা লাগতে পারে, যদি CheckoutPage নিজেই Navigate না করে থাকে
    // <Navigate to="/thank-you" replace state={{ orderData: orderInfo }} />
  };
  // ----------------------------------------------------------------

  useUTM(); // ✅ এই একটা line যোগ করো — যেকোনো route এ capture করবে


  usePageTracking();



  const [userEmail, setUserEmail] = useState(null);
  const [userName, setUserName] = useState(null);
  const [userPicture, setUserPicture] = useState(null);
  const [apiResponse, setApiResponse] = useState(null);

  const handleCredentialResponse = async (response) => {
    try {
      const decodedToken = jwtDecode(response.credential); // jwt-decode ব্যবহার করে
      console.log('Decoded Token:', decodedToken);

      const email = decodedToken.email;
      const name = decodedToken.name;
      const clientId = decodedToken.aud; // client_id সাধারণত audience (aud) ফিল্ডে থাকে

      setUserEmail(email);
      setUserName(name);
      setUserPicture(decodedToken.picture);

      const externalId = localStorage.getItem('client_id');

      // Flask API তে ডেটা পাঠান
      const apiBackendUrl = "https://aman-life-style-bd-main-server.sparkx-ai.shop/api/save_user_data"; // আপনার Flask API এর URL

      const apiRes = await fetch(apiBackendUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: email,
          name: name,
          clientId: externalId, // local storage থেকে প্রাপ্ত client_id
        }),
      });

      const data = await apiRes.json();
      setApiResponse(data);
      console.log('Flask API Response:', data);

      if (data.status === "exists") {
        // alert(`User with email ${email} already exists. No new save.`);
      } else if (data.status === "saved") {
        // alert(`User data for ${email} saved successfully!`);
      }

    } catch (error) {
      console.error('Error handling credential response or sending to API:', error);
      setApiResponse({ message: `Error: ${error.message}` });
    }
  };



  const [userEmailByClient, setUserEmailByClient] = useState(null);

  const [geterror, setgetError] = useState(null);

  useEffect(() => {
    const fetchUserEmail = async () => {
      setgetError(null);

      // localStorage থেকে client_id নিন
      const clientId = localStorage.getItem('client_id'); // <-- এখান থেকে client_id নেওয়া হচ্ছে

      if (!clientId) {
        setgetError("Client ID not found in localStorage.");

        return;
      }

      // Flask API এর URL
      const apiBackendUrl = `https://aman-life-style-bd-main-server.sparkx-ai.shop/api/get_user_email_by_client_id?clientId=${clientId}`;

      try {
        const response = await fetch(apiBackendUrl);
        const data = await response.json();

        if (response.ok && data.success) { // সার্ভার 200 OK দিয়েছে এবং success: true
          setUserEmailByClient(data.email);
        } else {
          // সার্ভার রেসপন্স 200 OK হলেও, data.success False হতে পারে (যেমন, ইমেল না পেলে)
          // অথবা সার্ভার 500 এরর দিতে পারে।
          setgetError(data.message || "Failed to fetch user email.");
          setUserEmailByClient(null); // ইমেল না পাওয়া গেলে null সেট করুন
        }
      } catch (err) {
        // নেটওয়ার্ক এরর বা JSON পার্সিং এরর হলে
        console.error("Network or parsing error:", err);
        setgetError("Network error or invalid response from API.");
        setUserEmailByClient(null);
      } finally {

      }
    };

    fetchUserEmail();
  }, []); // কম্পোনেন্ট মাউন্ট হওয়ার সময় শুধু একবার কল হবে




  return (
    <>
      {loading && ( // লোডিং থাকলে FullScreenLoader দেখাবে
        <FullScreenLoader>
          <Lottie
            animationData={animationData}
            loop={true}
            autoplay={true}
            style={{ width: 300, height: 300 }} // Lottie অ্যানিমেশনের আকার
          />
        </FullScreenLoader>
      )}


      {/* <div style={{ textAlign: 'center', marginTop: '50px' }}> */}


      {/* Google One Tap কম্পোনেন্ট যোগ করুন */}
      {   /* <GoogleOneTap onCredentialResponse={handleCredentialResponse} /> */}

      {/* {userEmail && (
        <div style={{ marginTop: '30px', border: '1px solid #ccc', padding: '20px', borderRadius: '8px' }}>
          <h2>সংগৃহীত তথ্য:</h2>
          <p><strong>ইমেল:</strong> {userEmail}</p>
          <p><strong>নাম:</strong> {userName}</p>
          {userPicture && <img src={userPicture} alt="User" style={{ borderRadius: '50%', width: '80px', height: '80px' }} />}
        </div>
      )} */}

      {/* {!userEmail && (
        <p style={{ color: 'gray', marginTop: '20px' }}>
          উপরে ডান কোণে Google One Tap প্রম্পটটি দেখুন।
        </p>
      )} */}
      {/* </div> */}

      {/* লোডিং না থাকলে বাকি অ্যাপ রেন্ডার হবে */}
      {!loading && (
        <>
          <ScrollToTop />

          {/* Header শুধু landing page না হলে দেখাবে */}
          {!isLandingPage && (
            <Header
              cartItemCount={cart.reduce((acc, item) => acc + item.quantity, 0)}
              onSearchClick={() => setIsSearchOverlayOpen(true)}   // আগের মতোই
              isAuthenticated={isAuthenticated}
              userInfo={userInfo}
              onLogout={logout}
            />
          )}
          <MainContent>
            {error ? (
              <ErrorMessage>{error}</ErrorMessage>
            ) : (
              <Routes>
                <Route
                  path="/"
                  element={


                    <AllProduct
                      products={filteredProducts}
                      addToCart={addToCart}
                      toggleFavorite={toggleFavorite}
                      isFavorite={isFavorite}
                      cartItems={cart}
                      searchTerm={searchTerm}
                      onSearchChange={handleSearchChange}
                      onSearchSubmit={handleSearchSubmit}
                      offerContact={offerContact}
                      setOfferContact={setOfferContact}
                      offerType={offerType}
                      setOfferType={setOfferType}
                      handleOfferSubmit={handleOfferSubmit}
                      currentPage={currentPage}
                      totalPages={totalPages}
                      onPageChange={setCurrentPage}
                    />
                    // <ProductList
                    //   products={filteredProducts}
                    //   addToCart={addToCart}
                    //   toggleFavorite={toggleFavorite}
                    //   isFavorite={isFavorite}
                    //   cartItems={cart}
                    //   searchTerm={searchTerm}
                    //   onSearchChange={handleSearchChange}
                    //   onSearchSubmit={handleSearchSubmit}
                    //   offerContact={offerContact}
                    //   setOfferContact={setOfferContact}
                    //   offerType={offerType}
                    //   setOfferType={setOfferType}
                    //   handleOfferSubmit={handleOfferSubmit}
                    //   currentPage={currentPage}
                    //   totalPages={totalPages}
                    //   onPageChange={setCurrentPage}
                    // />
                  }
                />



                <Route
                  path="/product"
                  element={
                    <AllProduct
                      products={filteredProducts}
                      addToCart={addToCart}
                      toggleFavorite={toggleFavorite}
                      isFavorite={isFavorite}
                      cartItems={cart}
                      searchTerm={searchTerm}
                      onSearchChange={handleSearchChange}
                      onSearchSubmit={handleSearchSubmit}
                      offerContact={offerContact}
                      setOfferContact={setOfferContact}
                      offerType={offerType}
                      setOfferType={setOfferType}
                      handleOfferSubmit={handleOfferSubmit}
                      currentPage={currentPage}
                      totalPages={totalPages}
                      onPageChange={setCurrentPage}
                    />
                  }
                />


                <Route
                  path="/products"
                  element={
                    <AllProduct
                      products={filteredProducts}
                      addToCart={addToCart}
                      toggleFavorite={toggleFavorite}
                      isFavorite={isFavorite}
                      cartItems={cart}
                      currentPage={currentPage}
                      totalPages={totalPages}
                      onPageChange={setCurrentPage}
                    />
                  }
                />

                <Route path="/all-post" element={<BlogList />} />
                <Route path="/post/:id/:titleSlug" element={<BlogDetail />} />

                <Route
                  path="/contact-us"
                  element={
                    < ContactUsPage />
                  }
                />

                <Route
                  path="/bd"
                  element={
                    < BangladeshLocation />
                  }
                />

                <Route
                  path="/privacy-policy"
                  element={
                    < PrivacyPolicy />
                  }
                />


                <Route
                  path="/fb/privacy-policy"
                  element={
                    < FacebookPrivacyPolicy />
                  }
                />

                <Route path="/track-parcel/:id" element={<ParcelTrackingPage />} />

                {/* যদি শুধু /track-parcel/ থাকে এবং কোনো আইডি না থাকে, তবে এই রুটটি ধরবে */}
                <Route path="/track-parcel/" element={<ParcelTrackingPage />} />

                <Route
                  path="/product/:id/:titleSlug"
                  element={
                    <ProductDetails
                      addToCart={addToCart}
                      cartItem={cart}
                      toggleFavorite={toggleFavorite}
                      isFavorite={isFavorite}
                      getAuthHeaders={getAuthHeaders}
                    />
                  }
                />
                <Route
                  path="/cart"
                  element={
                    <CartPage
                      cartItems={cart}
                      updateCartQuantity={updateCartQuantity}
                      removeFromCart={removeFromCart}
                      setCart={setCart}
                      updateCartItemOptions={updateCartItemOptions}
                    />
                  }
                />
                <Route
                  path="/checkout"
                  element={
                    <CheckoutPage cartItems={cart} setCart={setCart} onCheckoutComplete={handleCheckoutComplete} />
                    // addOrder={addOrder} এই প্রপসটি পরিবর্তন করে onCheckoutComplete করা হয়েছে
                  }
                />
                {/* ThankYouPage এ orderData প্রপস হিসেবে পাঠানো হচ্ছে */}
                <Route path="/thank-you" element={<ThankYouPage orderData={lastOrderData} />} />

                <Route path="/about" element={<AboutUsPage />} />
                <Route path="/refund-policy" element={<RefundPolicyPage />} />

                <Route
                  path="/order-history"
                  element={<ProtectedRoute><OrderHistoryPage orders={orders} addReviewToOrder={addReviewToOrder} products={products} /></ProtectedRoute>}
                />
                <Route
                  path="/favorites"
                  element={
                    <FavoritesPage
                      favoriteProducts={favoriteProducts}
                      products={products}
                      toggleFavorite={toggleFavorite}
                      addToCart={addToCart}
                    />
                  }
                />


                <Route
                  path="/l/:landingRoute"
                  element={
                    <LandingPage
                      addToCart={addToCart}
                      cartItem={cart}
                      getAuthHeaders={getAuthHeaders}
                      setCart={setCart}
                    />
                  }
                />

                <Route path="/login" element={<LoginPage />} />
                <Route path="/register" element={<Navigate to="/login" replace />} />
                <Route path="/faq" element={<FAQPage />} />
                <Route path="/myorders" element={<MyOrdersPage />} />
                <Route path="/delivery-man/:phone" element={<DeliveryManInfo />} />
                <Route
                  path="/profile"
                  element={
                    <ProtectedRoute>
                      <ProfilePage />
                    </ProtectedRoute>
                  }
                />
                <Route path="*" element={<NotFoundPage />} />
              </Routes>
            )}
          </MainContent>
          <Footer />

          {/* Bottom Navigation - শুধু landing page না হলে দেখাবে */}
          {!isLandingPage && (
            <BottomNavigation
              cartItemCount={cart.reduce((acc, item) => acc + item.quantity, 0)}
            />
          )}

          <SearchOverlay
            isOpen={isSearchOverlayOpen}
            onClose={() => setIsSearchOverlayOpen(false)}
            searchTerm={searchTerm}
            onSearchChange={handleSearchChange}
            onSearchSubmit={handleSearchSubmit}
          />
          <PromoPopup
            isOpen={isPromoPopupOpen}
            onClose={() => setIsPromoPopupOpen(false)}
            imageUrl={promoImageUrl}
            altText="বিশেষ অফার! ডিসকাউন্ট পেতে এখনই সাইন আপ করুন।"
          />
          <PhoneInputPopup
            isOpen={isPhonePopupOpen}
            onClose={() => setIsPhonePopupOpen(false)}
            onSubmitPhone={handlePhoneSubmit}
          />
        </>
      )}
    </>
  );
}

function App() {
  return (
    <LicenseGuard>
      <Router>
        <AuthProvider>
          <AppContent />
        </AuthProvider>
      </Router>
    </LicenseGuard>
  );
}

export default App;